import type { Role } from '@takeshape/schema';
import type { ActionType } from 'typesafe-actions';
import { createRoutine } from '../common/utils/new-routines.js';
import type { UserRole } from './user-role-schema.js';

export type SaveRolePayload = Pick<Role, 'name' | 'permissions' | 'conditions'>;

export const getRoleListRoutine = createRoutine('userRole/GET_LIST')<
  undefined,
  undefined,
  undefined,
  UserRole[],
  string,
  undefined
>();

export const saveRoleRoutine = createRoutine('userRole/SAVE_ROLE')<
  undefined,
  SaveRolePayload,
  undefined,
  UserRole,
  string,
  undefined
>();

export type SaveRoleRoutineActionType = ActionType<typeof saveRoleRoutine>;

export const updateRoleRoutine = createRoutine('userRole/UPDATE_ROLE')<
  undefined,
  SaveRolePayload,
  undefined,
  UserRole,
  string,
  undefined
>();
export type UpdateRoleRoutineActionType = ActionType<typeof updateRoleRoutine>;

export const removeRoleRoutine = createRoutine('userRole/REMOVE_ROLE')<
  undefined,
  string,
  undefined,
  undefined,
  string,
  undefined
>();
export type RemoveRoleRoutineActionType = ActionType<typeof removeRoleRoutine>;
